export enum Bites {
	AdditionalCentric = 'AdditionalCentricBite',
	RightLateralExcursion = 'RightLateralBite',
	LeftLateralExcursion = 'LeftLateralBite',
	Protrusive = 'ProtrusiveBite',
	Retrusive = 'RetrusiveBite'
}
